import { render, staticRenderFns } from "./DefaultClientPhoneDlg.vue?vue&type=template&id=60c9bad0"
import script from "./DefaultClientPhoneDlg.vue?vue&type=script&lang=ts"
export * from "./DefaultClientPhoneDlg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports